var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareUrl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#DFDFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.037 19.154C10.83 19.154 12.04 18.164 12.04 15.535V10.904H10.808V15.612C10.808 17.438 10.049 18.032 9.037 18.032C8.025 18.032 7.299 17.438 7.299 15.612V10.904H6.023V15.535C6.023 18.164 7.233 19.154 9.037 19.154ZM13.6834 19H14.9704V15.733H16.3344C18.0064 15.733 19.2604 14.952 19.2604 13.258C19.2604 11.498 18.0064 10.904 16.3344 10.904H13.6834V19ZM14.9704 14.71V11.938H16.1914C17.3574 11.938 17.9954 12.279 17.9954 13.258C17.9954 14.226 17.3574 14.71 16.1914 14.71H14.9704ZM18.1164 19H19.5464L17.0384 14.655L16.0924 15.403L18.1164 19ZM20.4621 19H25.1811V17.922H21.7491V10.904H20.4621V19Z",
    fill: "#141415"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareUrl);
export default __webpack_public_path__ + "static/media/share__url.62dcfd034c51da737ec91878ff047cef.svg";
export { ForwardRef as ReactComponent };